export default __webpack_public_path__ + "static/media/dialogue-background.b5bfd8b7.png";